export default "__VITE_ASSET__Bta3jBID__"